'use strict';

var ng2 = true;
var module = {id:''};
